import { Card, Col, Form, Row } from 'react-bootstrap';
import { buildEngineOilAttributes, ENGINE_OIL_VARIANTS, ENGINE_OIL_VISCOSITIES } from '../../utils/engineOilAdminAttributes';

export { buildEngineOilAttributes };

const OIL_TYPES = ['', 'Full Synthetic', 'Synthetic Blend', 'Conventional'];
const VISCOSITIES = ENGINE_OIL_VISCOSITIES;
const VARIANTS = ENGINE_OIL_VARIANTS;
const VOLUMES = ['', '1 L', '4 L', '5 L'];
const FUEL_APPLICATIONS = ['', 'Gasoline', 'Diesel', 'Gasoline & Diesel', 'Other'];

const TextField = ({ label, attributeKey, attributes, onChange, ...props }) => (
  <Form.Group className="my-2">
    <Form.Label>{label}</Form.Label>
    <Form.Control value={attributes[attributeKey] || ''} onChange={(event) => onChange(attributeKey, event.target.value)} {...props} />
  </Form.Group>
);

export default function EngineOilProductFields({ attributes, onChange }) {
  const select = (label, attributeKey, options) => (
    <Form.Group className="my-2">
      <Form.Label>{label}</Form.Label>
      <Form.Select value={attributes[attributeKey] || ''} onChange={(event) => onChange(attributeKey, event.target.value)}>
        {options.map((option) => <option key={option || 'blank'} value={option}>{option || 'Select'}</option>)}
      </Form.Select>
    </Form.Group>
  );

  return (
    <Card className="my-3 border-0 shadow-sm">
      <Card.Body>
        <h2 className="h5 mb-1">Engine Oil Details</h2>
        <Form.Text muted>Use the supplier's documented oil specifications. Do not infer vehicle fitment.</Form.Text>
        <Row className="mt-2">
          <Col md={4}>{select('Oil Type', 'Oil Type', OIL_TYPES)}</Col>
          <Col md={4}>{select('Viscosity / SAE Grade', 'Viscosity', VISCOSITIES)}</Col>
          <Col md={4}>{select('Variant / Product Version', 'Variant', VARIANTS)}</Col>
          <Col md={4}>{select('Volume', 'Volume', VOLUMES)}</Col>
          <Col md={4}><TextField label="Product Line / Series" attributeKey="Product Line" attributes={attributes} onChange={onChange} placeholder="AVES" /></Col>
          <Col md={4}>{select('Fuel / Engine Application', 'Fuel Application', FUEL_APPLICATIONS)}</Col>
          <Col md={4}><TextField label="API Specification" attributeKey="API" attributes={attributes} onChange={onChange} placeholder="API SP (RC)" /></Col>
          <Col md={4}><TextField label="ACEA Specification" attributeKey="ACEA" attributes={attributes} onChange={onChange} placeholder="ACEA C3" /></Col>
          <Col md={4}><TextField label="ILSAC Specification" attributeKey="ILSAC" attributes={attributes} onChange={onChange} placeholder="ILSAC GF-6A" /></Col>
        </Row>
        <TextField
          label="OEM / Manufacturer Approvals"
          attributeKey="OEM / Manufacturer Specifications"
          attributes={attributes}
          onChange={onChange}
          as="textarea"
          rows={3}
          placeholder="Enter multiple approvals separated by commas"
        />
        <Form.Text muted>Separate multiple documented approvals with commas.</Form.Text>
        <TextField
          label="Full Specification / Technical Description"
          attributeKey="Specifications"
          attributes={attributes}
          onChange={onChange}
          as="textarea"
          rows={4}
        />
      </Card.Body>
    </Card>
  );
}
